function initProductCategory() {
  $("#filter-toggle-button").click(function () {
    $(this).children().toggleClass("fa-sliders-h fa-times");
    $("#filter-toggle").slideToggle();
  });

  $("#sort-toggle-btn").click(function () {
    $(this)
      .find(".fa-chevron-up, .fa-chevron-down")
      .toggleClass("fa-chevron-up fa-chevron-down");
    $("#sort-toggle").slideToggle();
  });

  if ($(".currentcat")[0]) {
    var catid = $(".currentcat").data("catid");

    if ($("a[data-catlinkid=" + catid + "]").hasClass("parentlink")) {
      $(".btn[data-catlinkid=" + catid + "]").trigger("click");
      $("a[data-catlinkid=" + catid + "]").css("color", "#ff0940");
    }

    if ($("a[data-catlinkid=" + catid + "]").hasClass("childlink")) {
      $("a[data-catlinkid=" + catid + "]")
        .parent()
        .parent()
        .parent()
        .children()
        .children("button")
        .trigger("click");
      $("a[data-catlinkid=" + catid + "]").css("color", "#ff0940");
    }

    if ($("a[data-catlinkid=" + catid + "]").hasClass("catlink")) {
      $("a[data-catlinkid=" + catid + "]").css("color", "#ff0940");
    }
  }
}
